import {
  SET_ALL_USERS,
  SET_USER_URN
} from './types'

export const setAllUsers = (allUsers:any[]) => ({
  type: SET_ALL_USERS,
  allUsers
})

export const setUserUrn = (userUrn:string) => ({
  type: SET_USER_URN,
  userUrn
})
